
import TouchFeedback from './src/TouchFeedback';
export default TouchFeedback;


// WEBPACK FOOTER //
// ./index.js